import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './jewelry/Header';
import Footer from './jewelry/Footer';
import Home from './jewelry/Home';
import Specimens from './jewelry/Specimens';
import Process from './jewelry/Process';
import Commission from './jewelry/Commission';

export default function JewelryTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#0B0A0E]" data-testid="jewel-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`jewel-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'specimens' && <Specimens setPage={setPage} />}
          {page === 'process' && <Process setPage={setPage} />}
          {page === 'commission' && <Commission setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
